// src/redux/actions/siteActions.js
export const SET_ALERT_TREND = 'SET_ALERT_TREND';

export const setSetalerttrendList = (alerttrendList) => ({
  type: SET_ALERT_TREND,
  payload: alerttrendList,
});
